module.exports = __webpack_public_path__ + "img/github-primary.74401878.svg";